import { capitalize } from 'lodash';
import { Tag } from '../components/tag';

export type EventStatus = 'upcoming' | 'ongoing' | 'ended';

export function getEventStatus(
    startDate: Date,
    endDate: Date,
    now: Date = new Date()
): EventStatus | null {
    if (now < startDate) {
        return 'upcoming';
    } else if (now >= startDate && now <= endDate) {
        return 'ongoing';
    } else if (now > endDate) {
        return 'ended';
    }

    return null;
}

/*  
  Tags
*/

export function EventStatusTag({ status }: { status: EventStatus }) {
    const text = capitalize(status);
    switch (status) {
        case 'upcoming':
            return (
                <Tag variant="blue">
                    <span>⏰</span>
                    {text}
                </Tag>
            );
        case 'ongoing':
            return (
                <Tag variant="success">
                    <span>✓</span>
                    {text}
                </Tag>
            );
        case 'ended':
            return (
                <Tag variant="orange">
                    <span>⏹</span>
                    {text}
                </Tag>
            );
    }
}
